<template>
  <div>
    <h2 class="heading-tertiary">{{ $t('parameters.syncPrestaNode.title') }}</h2>

    <div class="box-card SyncPrestaNodeQueue" v-for="queue in queueList" :key="queue._id" v-infinite-scroll="getSyncQueue"
    infinite-scroll-disabled="disableGetSyncQueueInfiniteScroll"
    infinite-scroll-distance=100>
      <div class="SyncPrestaNodeQueue__header">
        <h2 >{{(queue.id_queue == -1 ?'Node':'Presta')}}</h2>
        <div><span class="u-arrow-right"></span></div>
        <h2 >{{(queue.id_queue == -1 ?'Presta':'Node')}}</h2>
        <div>
        <el-tag
          :type="getColorMethod(queue.method.toUpperCase())" effect="dark">
          {{ queue.method.toUpperCase() }}
        </el-tag>
        </div>
        <h2>/{{queue.url}}</h2>
      </div>

      <div class="SyncPrestaNodeQueue__content">
        <div class="SyncPrestaNodeQueue__content--code-error">
          <h2>{{queue.http_status || '&nbsp;'}}</h2>
        </div>
        <div class="SyncPrestaNodeQueue__content--step">
           <el-steps :active="getState(queue)" finish-status="success" :process-status="queue.error?'error':'success'">
            <el-step :title="$t('parameters.syncPrestaNode.ask')"></el-step>
            <el-step :title="$t('parameters.syncPrestaNode.ack')"></el-step>
            <el-step :title="$t('parameters.syncPrestaNode.treated')"></el-step>
          </el-steps>
          {{(queue.message_error)}}
        </div>
        <div class="SyncPrestaNodeQueue__content--actions">
          <svg class="table__icon table__icon--medium">
            <use href="@/assets/sprite.svg#icon-info-circle"></use>
          </svg>
          <svg class="table__icon table__icon--medium" @click="currentQueue=queue;replayQueue(true)">
            <use href="@/assets/sprite.svg#icon-reload"></use>
          </svg>
          <svg class="table__icon table__icon--medium" @click="deleteQueue(queue._id,queue.id_queue)">
            <use href="@/assets/sprite.svg#icon-cancel"></use>
          </svg>
        </div>
      </div>
    </div>
    <transition name="popup">
      <SyncPrestaNodeReplayQueue v-if='getShowReplayQueue' :queue="currentQueue" @popup:forceRefresh='reset()'></SyncPrestaNodeReplayQueue>
    </transition>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import { HTTP_CLIENT } from '@/axios-wrapper'
import { toastMixin } from '@/components/Mixins/Toast'
import { dialogboxMixin } from '@/components/Mixins/Dialogbox'
import SyncPrestaNodeReplayQueue from '@/views/popup/SyncPrestaNodeReplayQueue'

const { mapGetters, mapMutations } = createNamespacedHelpers('syncPrestaNode')

export default {
  data: function () {
    return {
      noMoreNode: false,
      loading: false,
      currentPageNode: 1,
      noMorePresta: false,
      loadingPresta: false,
      currentPagePresta: 1,
      queueList: [],
      currentQueue: undefined,
      dialogBoxDelete: {
        title: this.$t('dialog.syncPrestaNode.delete.title'),
        cancelAction: this.$t('dialog.syncPrestaNode.delete.cancelAction'),
        confirmAction: this.$t('dialog.syncPrestaNode.delete.confirmAction'),
        default: 'cancel'
      }
    }
  },
  computed: {
    ...mapGetters(['getShowReplayQueue']),
    disablegetSyncQueueInfiniteScroll () {
      return this.noMore || this.loading
    }
  },
  components: {
    SyncPrestaNodeReplayQueue
  },
  mixins: [toastMixin, dialogboxMixin],
  methods: {
    ...mapMutations({
      replayQueue: 'SHOW_REPLAY_QUEUE_POPUP'
    }),
    getState (queue) {
      if (queue.treated && queue.ack && !queue.error) return 3
      if (queue.ack) return 2
      if (queue.ask) return 1
      return 0
    },
    reset () {
      this.noMoreNode = false
      this.loading = false
      this.currentPageNode = 1
      this.currentPagePresta = 1
      this.queueList = []
      this.getSyncQueue()
    },
    async getSyncQueue () {
      try {
        this.loading = true
        let { data } = await HTTP_CLIENT.get(`queueSync?sort= date&page=${this.currentPageNode}&limit=10`)

        if (data.length) {
          this.queueList.push(...data)
          this.noMoreNode = false
          this.currentPageNode++
        } else {
          this.noMoreNode = true
        }
        this.loading = false
      } catch (error) { console.log(error) }
    },

    async deleteQueue (id, idQueue) {
      try {
        const ret = await this.msgbox(this.dialogBoxDelete)
        if (ret === 'confirm') {
          await HTTP_CLIENT.delete(`queueSync/${id}`)
          // TODO supprimer de presta
          if (idQueue !== -1) { }
          this.sendSuccessToast(this.$t('feedback-ok.syncPrestaNode.delete'))
          this.reset()
        }
      } catch (err) {
        this.sendErrorToast(this.$t('feedback-err.syncPrestaNode.delete'))
      }
    },
    getColorMethod (method) {
      switch (method) {
        case 'GET' :
          return 'success'
        case 'PUT' :
          return 'primary'
        case 'DELETE' :
          return 'danger'
        case 'POST' :
          return 'warning'
      }
    }
  },
  created () {
    this.reset()
  }
}
</script>
